import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './main/App';
import * as serviceWorker from './serviceWorker';
import { isIos, isMobile } from 'lib/devices';
import { sf3DesktopUri } from 'config/api';

declare const iNoBounce: {
    enable: () => void;
    disable: () => void;
    isEnabled: () => boolean;
};

if (!isMobile()) {
    window.location.href = sf3DesktopUri;
} else {
    if (isIos()) {
        iNoBounce.enable();
    } else {
        iNoBounce.disable();
    }

    ReactDOM.render(<App />, document.getElementById('root'));

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    if (process.env.NODE_ENV === 'production') {
        serviceWorker.register();
    } else {
        serviceWorker.unregister();
    }
}

